import { FC, MouseEvent } from 'react'
import styled, { css } from 'styled-components'
import ExpandMoreIcon from 'svgIcons/ExpandMore'

interface IFProps {
  selectValue: string
  isFocused: boolean
  disabled?: boolean
  onClick: () => void
}

const SelectBox: FC<IFProps> = ({
  selectValue,
  isFocused,
  disabled = false,
  onClick,
}) => {
  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()

    if (!disabled) {
      onClick()
    }
  }

  return (
    <StyledWrapper onClick={handleClick} data-focused={isFocused}>
      <p>{selectValue}</p>
      <i className="icon-arrow">
        <ExpandMoreIcon />
      </i>
    </StyledWrapper>
  )
}

export default SelectBox

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 40px;
    padding: 13px 10px 13px 15px;
    border-radius: 8px;
    border: solid 1px ${theme.line.line_2};
    background-color: ${theme.background.bg_8};
    display: flex;
    align-items: center;
    justify-content: space-between;
    user-select: none;

    &[data-focused='true'] {
      border: solid 1px ${theme.color.primary_2};
    }

    & > p {
      height: 24px;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.64px;
      text-align: left;
    }

    & > p {
      font-weight: 500;
      color: ${theme.color.text_1};
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
    }

    & > i {
      width: 24px;
      height: 24px;
      text-align: center;
    }
  `}
`
